<template>
  <div>&nbsp;</div>
</template>

<script setup name="logout">
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/store";
import * as cmUtil from "@/utils/cmUtil";
import * as cmApi from "@/api/cmApi";
const router = useRouter();
// import { removeLocalStorage } from "@/utils/cmUtil.js";

/**********************
 * 마운트
 *********************/
onMounted(() => {
  //cmUtil.loading("로그아웃 중입니다...", { duration: 500 });
  const logoutSatus = cmUtil.getLocalStorage("gv.logoutSatus") || "";
  if (logoutSatus === "1") {
    cmUtil.removeLocalStorage("gv.logoutSatus");
    //setTimeout(() => {
    //location.href = "/"; // 로그인 페이지로 이동
    //router.push("/");
    window.history.pushState(null, "", router.push("/paintpro/login"));
    //}, 100);
  } else {
    logout();
  }
  // setTimeout(() => {
  //   logout();
  // }, 100);
});

async function logout() {
  await cmApi.logout();
  const authStore = useAuthStore();
  authStore.logout();
  //removeLocalStorage("token");
  //window.history.go(-(window.history.length - 1));
  //location.href = "/"; // 로그인 페이지로 이동

  if ("caches" in window) {
    caches.keys().then((cacheNames) => {
      cacheNames.forEach((cacheName) => {
        caches.delete(cacheName);
      });
    });
  }
  // 3. 페이지를 새로고침하여 모든 캐시 초기화
  cmUtil.setLocalStorage("gv.logoutSatus", "1");
  window.location.reload();
}
</script>

<style></style>
